module.exports = __webpack_public_path__ + "img/antigua-and-barbuda.7e594a00.svg";